<template>
  <div>
      <div class="header2">
      <van-nav-bar
        title="抽奖名称"
        left-text="返回"
        left-arrow
        @click-left="goBack"
      />
    </div>
    <van-form @submit="creatSurvey">
        <div class="form-sty">
        <van-field
          required
          v-model="title.name"
          label="活动名称"
          placeholder="活动名称"
          :rules="[{ required: true, message: '请填写活动名称' }]"
        />
      </div>
       <div class="form-sty">
        <van-field
          required
          v-model="title.info"
          label="活动描述"
          placeholder="活动描述"
          :rules="[{ required: true, message: '请填写活动描述' }]"
        />
      </div>
      <van-field
        readonly
        clickable
        name="datetime"
        :value="title.time"
        label="开奖时间"
        placeholder="点击选择时间"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-datetime-picker
          type="datetime"
          title="选择开奖时间"
          v-model="currentDate"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="onTimeIn"
          @changeFn="onShift"
          @cancel="showPicker = false"
        />
      </van-popup>
        <div class="created-tit" style="margin: 16px;">
            <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
    </van-form>
  </div>
</template>
<script>
import URL from "@/api/api";
export default {
  data() {
    return {
      isShowImg:false,
      currentDate: new Date(),
       showPicker: false,

      title: {name:'',info:'',time:'',status:0,openid:localStorage.getItem("openid")},

      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
    };
  },
  methods: {
    onShift() {
      this.changeDate = this.currentDate; // Tue Sep 08 2020 00:00:00 GMT+0800 (中国标准时间)
    },
     onTimeIn(value) {
      this.title.time = this.timeFormat(this.currentDate);
      this.showPicker = false;
    },
    timeFormat(time) { // 时间格式化 2019-09-08de
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let hour = time.getHours();
      let minute = time.getMinutes();
      return year + "-" + month + "-" + day + " " + hour + ":" + minute;
    },
    goBack() {
      this.$router.go(-1)
    },
    creatSurvey(){
      this.title.openid=localStorage.getItem("openid")
      this.$fetchPost(URL.savebatchInfo.url,this.title).then(res=>{
          this.$router.push({path:'/newLottery/details',query:{id:res.data.data.id,type:'1'}})
      })
      
    }
  },
};
</script>
<style scoped>
.created-tit >>> .van-button--info {
  width: 95%;
  border-radius: 5px;
  border: 1px solid;
}
.form-sty >>> .van-cell {
  display: block;
}
.form-sty >>> .van-field__control {
  border: 1px solid #c0c4cc;
  border-radius: 5px;
  padding: 10px 5px;
}

</style>